import styles from "./IncidentDocumentation.module.css";
import PropTypes from "prop-types";
import { useState } from "react";
import classNames from "classnames";

/**
 *
 * Displays the documentation about an incident under the documentation tab on the incident details page.
 *
 */

export function IncidentDocumentation({
  description,
  documentedEvidence,
  onSubmit,
  onDownload,
}) {
  const [descriptionLocal, setDescriptionLocal] = useState(description);

  const [fileList, setFileList] = useState([]);
  function handleFileUpload(e) {
    const files = [...e.target.files];
    setFileList([...files]);
  }

  const handleSubmit = () => {
    let documentObject = {
      files: fileList,
      description: descriptionLocal,
    };
    onSubmit(documentObject);
    setFileList([]);
  };
  return (
    <>
      <div className={styles.container}>
        <div className={styles.leftSide}>
          <div className={styles.title}>Description of Event</div>
          <textarea
            className={classNames(styles.textarea, styles.biggerTextArea)}
            placeholder="Description…"
            onChange={(e) => setDescriptionLocal(e.target.value)}
          >
            {descriptionLocal}
          </textarea>
          <div className={styles.fileUploadButtonContainer}>
            <div className={styles.fileUploadContainer}>
              <label htmlFor="documents" className={styles.fileUpload}>
                {fileList.length === 0
                  ? "Upload Documents"
                  : fileList.map((file, index) =>
                      index === fileList.length - 1
                        ? `${file.name}`
                        : `${file.name}, `
                    )}
              </label>

              <input
                className={styles.fileUpload}
                type="file"
                id="documents"
                onChange={(e) => handleFileUpload(e)}
                multiple
              />
            </div>
            <div className={styles.buttonContainer}>
              <button className={styles.button} onClick={() => handleSubmit()}>
                Save
              </button>
            </div>
          </div>
        </div>
        <div className={styles.rightSide}>
          <div className={styles.title}>Documented Evidence</div>
          <div className={styles.documentsContainer}>
            {documentedEvidence.map((item, index) => (
              <div
                className={index % 2 == 0 && styles.slightlyDarkerBackground}
              >
                <p
                  className={styles.documentedEvidenceItem}
                  key={index}
                  onClick={() => onDownload(item)}
                >
                  {item.name}
                </p>
                {/* <img src={item.src} /> test*/}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

IncidentDocumentation.propTypes = {
  description: PropTypes.string,
  documentedEvidence: PropTypes.arrayOf(PropTypes.object),
};
